<div class="menu">
    <div *ngFor="let menu of menuItems">
        <div *ngIf="menu.items.length === 0 && menu.key !== 'separator'" class="menu-item" (click)="onClickMenuItem($event, menu)"
            [ngClass]="{'selected-item': menu.isSelected}" [attr.data-info-text]="menu.infoText">
            <div class="menu-item-wrapper">
                <div class="menu-item-icon"></div>
                <div class="menu-item-value">{{menu.name}}</div>
                <div [ngClass]="{'has-error': menu.hasError}"></div>
                <div [ngClass]="{'has-info': menu.hasInfo}"></div>
            </div>            
        </div>

        <div *ngIf="menu.key === 'separator'">
            <div class="menu-item-separator"></div>
        </div>        

        <div *ngIf="menu.items.length > 0 && menu.key !== 'separator'" class="menu-item menu-item-with-items" (click)="onClickMenuWithSubItems($event, menu)" 
                [ngClass]="{'selected-item-with-subitems': menu.isSelected}">
          <div *ngIf="!menu.isOpen" class="menu-item-wrapper" id="wrapper-{{menu.key}}-closed">
              <div class="menu-item-icon"><i class="dx-icon dx-icon-spinright"></i></div>
              <div class="menu-item-value">{{menu.name}}</div>
              <div [ngClass]="{'has-error': menu.hasError}"></div>
              <div [ngClass]="{'has-info' : menu.hasInfo}"></div>
          </div>

          <div *ngIf="menu.isOpen" class="menu-item-wrapper" id="wrapper-{{menu.key}}-open">
              <div class="menu-item-icon"><i class="dx-icon dx-icon-spindown"></i></div>
              <div class="menu-item-value">{{menu.name}}</div>              
              <div [ngClass]="{'has-error': menu.hasError}"></div>
              <div [ngClass]="{'has-info': menu.hasInfo}"></div>
          </div>
        </div>        

        <div *ngIf="menu.isOpen && menu.key !== 'separator'" class="menu-item-subitem-container closed" id={{menu.key}}>
            <div *ngFor="let subItem of menu.items" class="submenu-item" 
                    [ngClass]="{'selected-item': subItem.isSelected, 'has-info-subitem': subItem.hasInfo}" [attr.data-info-text]="subItem.infoText"
                    (click)="onClickSubmenuItem($event, menu, subItem)">
                <div *ngIf="subItem.key === 'separator'">
                    <div class="menu-subitem-separator"></div>
                </div>
                <div [ngClass]="{'has-error': subItem.hasError}"></div>
                <div *ngIf="subItem.key !== 'separator'" class="submenu-item-wrapper">
                    <div class="submenu-item-icon">
                        <i *ngIf="subItem.icon !== undefined && subItem.icon.length > 0" [class]="'dx-icon' + ' ' + subItem.icon">&nbsp;</i>
                    </div>
                    <div class="submenu-item-value">{{subItem.name}}</div>
                </div>
            </div>
        </div>
    </div>
</div>

